<script lang="ts">
	import type { MotionBlockData } from '$lib/queries/content/MotionBlockQuery';
	import Canvas from '$lib/animations/ovals/Canvas.svelte';
	import { desktopLayouts } from '$lib/animations/ovals/MotionBlockDesktopLayouts';
	import { mobileLayouts } from '$lib/animations/ovals/MotionBlockMobileLayouts';
	import { Breakpoints } from '@tools';
	import GenreTags from '../GenreTags.svelte';
	import { ThinArrow } from '@icons';

	let { data }: { data: MotionBlockData } = $props();

	let layout = $state(mobileLayouts[0]);
	let item = $state(data.events[0]);

	$effect(() => {
		const layouts = Breakpoints.md ? desktopLayouts : mobileLayouts;
		let index = 0;
		layout = layouts[index];

		const intervalId = setInterval(() => {
			index++;
			layout = layouts[(index + 1) % layouts.length];
			item = data.events[index % data.events.length];
		}, 3500);

		return () => {
			clearInterval(intervalId);
		};
	});
</script>

{#if data.events.length > 0}
	<section>
		<Canvas {layout} />
		<div class="content">
			<a class="title text:h1" href={`/kalender/${item.slug}`}>{item.title}</a>
			<div class="genres">
				<GenreTags data={item.genres} />
			</div>
			<a class="link text:body-lg" href="/kalender">
				<span>Se hele programmet</span>
				<span class="button:round"><ThinArrow /></span>
			</a>
		</div>
	</section>
{/if}

<style lang="scss">
	section {
		display: flex;
		flex-direction: column;
		position: relative;
		background-color: $colorCardBackground;
		aspect-ratio: 1 / #{$ratio1};
		overflow: hidden;
		@include fullBleedBlock;

		@include md {
			aspect-ratio: #{$ratio3} / 1;
		}
	}

	.content {
		position: relative;
		z-index: 2;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: #{$gap6} var(--gutter);
	}

	.title {
		max-width: 9em;
		text-align: center;
		text-decoration: none;
		text-transform: uppercase;
	}

	.genres {
		display: flex;
		flex-wrap: wrap;
		gap: 0.4em;
		text-transform: lowercase;
		margin-top: $gap4;

		@include md {
			margin-top: $gap5;
		}
	}

	.link {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		margin-top: 1rem;
		text-decoration: none;
		margin-top: $gap6;

		@include md {
			margin-top: $gap7;
		}
	}
</style>
